/*
 * File: UserDropdown.tsx
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:02:25 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { useAuth0 } from '@auth0/auth0-react';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown } from 'antd';
import { MenuKeys } from 'common/enums/MenuKeys';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { useNavigate } from 'react-router-dom';
import { useGetUserQuery } from 'redux/services/useCookieMonster';

const styles: InlineStylesModel = {
  dropDown: {
    cursor: 'pointer'
  },
  menu: {
    alignItems: 'center',
    background: 'none',
    borderRight: 'none',
    display: 'flex',
    marginLeft: '8px'
  },
  menuIcon: {
    color: 'rgb(132, 133, 154)',
    fontSize: '18px',
    marginLeft: '5px'
  }
};

export const UserDropdown = (): JSX.Element => {
  const { logout, user } = useAuth0();

  const { data: userData, isLoading, isFetching } = useGetUserQuery(user?.sub as string, { skip: !user?.sub });

  const navigate = useNavigate();
  const versionNumber = process.env.REACT_APP_VERSION_NUMBER as string;

  const handleAboutPage = (): void => {
    navigate(`/about`);
  };

  const menuItems: MenuProps['items'] = [
    {
      label: <div onClick={handleAboutPage}>{MenuKeys.about}</div>,
      key: MenuKeys.about
    },
    {
      label: <div onClick={(): void => navigate(`/release-notes/${versionNumber}`)}>{MenuKeys.releaseNotes}</div>,
      key: MenuKeys.releaseNotes
    },
    {
      label: <a target="_blank" href={process.env.REACT_APP_PROFILE_URL} rel="noreferrer">
        {MenuKeys.profile}
      </a>,
      key: MenuKeys.profile
    },
    {
      label: <div onClick={(): void => logout({})}>{MenuKeys.logout}</div>,
      key: MenuKeys.logout
    }
  ];

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']}>
      <Avatar
        style={{ marginLeft: 8, cursor: 'pointer' }}
        src={userData && userData.user_metadata.profile_image_url ? userData.user_metadata.profile_image_url : !(isLoading || isFetching) ? user?.picture : null}
      />
    </Dropdown>
  );
};
